import { HTTPServerError } from './HTTPServerError';
export class HTTPInternalServerError extends HTTPServerError {
    constructor() {
        super(500 /* InternalServerError */, 'Internal Server Error');
    }
}
